module.exports = __webpack_public_path__ + "static/media/vihara.a4b437ee.svg";